import React from 'react';
import { SubsidiaryHeader } from '../../../components/shared/SubsidiaryHeader';
import { SubsidiaryFooter } from '../../../components/shared/SubsidiaryFooter';
const navigation = [{
  name: 'Home',
  href: '/puritydefine'
}, {
  name: 'Solutions',
  href: '#solutions'
}, {
  name: 'Industries',
  href: '#industries'
}, {
  name: 'Innovation',
  href: '#innovation'
}, {
  name: 'About',
  href: '#about'
}, {
  name: 'Contact',
  href: '#contact'
}];
const footerLinks = [{
  title: 'Solutions',
  items: [{
    name: 'Manufacturing',
    href: '#'
  }, {
    name: 'Quality Control',
    href: '#'
  }, {
    name: 'Supply Chain',
    href: '#'
  }, {
    name: 'Sustainability',
    href: '#'
  }]
}, {
  title: 'Company',
  items: [{
    name: 'About Us',
    href: '#'
  }, {
    name: 'Leadership',
    href: '#'
  }, {
    name: 'Careers',
    href: '#'
  }, {
    name: 'News',
    href: '#'
  }]
}];
const solutions = [{
  id: 'manufacturing',
  title: 'Advanced Manufacturing',
  description: 'State-of-the-art production facilities and processes delivering precision and quality.',
  icon: '⚙️'
}, {
  id: 'quality',
  title: 'Quality Assurance',
  description: 'Comprehensive quality control systems ensuring products meet the highest standards.',
  icon: '✓'
}, {
  id: 'supply',
  title: 'Supply Chain Solutions',
  description: 'Optimized logistics and inventory management for maximum efficiency.',
  icon: '🔄'
}, {
  id: 'sustainable',
  title: 'Sustainable Production',
  description: 'Environmentally responsible manufacturing practices reducing ecological impact.',
  icon: '🌱'
}];
const industries = [{
  id: 'consumer',
  name: 'Consumer Goods',
  image: 'https://images.unsplash.com/photo-1581553680321-4fffae59fcfa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
}, {
  id: 'healthcare',
  name: 'Healthcare',
  image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
}, {
  id: 'automotive',
  name: 'Automotive',
  image: 'https://images.unsplash.com/photo-1537462715879-360eeb61a0ad?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
}, {
  id: 'construction',
  name: 'Construction',
  image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
}];
export function PuritydefineHome() {
  return <div className="flex flex-col min-h-screen" data-id="element-869">
      <SubsidiaryHeader name="Puritydefine Nig Ltd" color="bg-blue-50 text-blue-900" navigation={navigation} logo="https://uploadthingy.s3.us-west-1.amazonaws.com/3HZq8reLfPNsnzSHGf7kcW/PURITY.png" data-id="element-870" />
      <main className="flex-grow" data-id="element-871">
        {/* Hero Section */}
        <section className="relative h-[70vh]" data-id="element-872">
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80')] bg-cover bg-center" data-id="element-873"></div>
          <div className="absolute inset-0 bg-blue-900/60" data-id="element-874"></div>
          <div className="relative z-10 container mx-auto px-4 h-full flex items-center" data-id="element-875">
            <div className="max-w-xl text-white" data-id="element-876">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6" data-id="element-877">
                Innovative Manufacturing Solutions
              </h1>
              <p className="text-xl md:text-2xl mb-8" data-id="element-878">
                Driving industry excellence through quality, innovation, and
                sustainable practices.
              </p>
              <div className="flex flex-wrap gap-4" data-id="element-879">
                <a href="#solutions" className="px-6 py-3 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 transition-colors" data-id="element-880">
                  Our Solutions
                </a>
                <a href="#contact" className="px-6 py-3 bg-transparent border border-white text-white font-medium rounded-md hover:bg-white/10 transition-colors" data-id="element-881">
                  Contact Us
                </a>
              </div>
            </div>
          </div>
        </section>
        {/* Solutions Section */}
        <section id="solutions" className="py-20" data-id="element-882">
          <div className="container mx-auto px-4" data-id="element-883">
            <h2 className="text-3xl font-bold text-center text-blue-900 mb-16" data-id="element-884">
              Our Solutions
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-885">
              {solutions.map(solution => <div key={solution.id} className="bg-white p-6 rounded-lg shadow-md border border-blue-100" data-id="element-886">
                  <div className="text-4xl mb-4" data-id="element-887">{solution.icon}</div>
                  <h3 className="text-xl font-bold text-blue-900 mb-3" data-id="element-888">
                    {solution.title}
                  </h3>
                  <p className="text-gray-700 mb-4" data-id="element-889">{solution.description}</p>
                  <a href="#" className="text-blue-600 font-medium hover:text-blue-700 flex items-center" data-id="element-890">
                    Learn More
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-1" viewBox="0 0 20 20" fill="currentColor" data-id="element-891">
                      <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" data-id="element-892" />
                    </svg>
                  </a>
                </div>)}
            </div>
          </div>
        </section>
        {/* Industries Section */}
        <section id="industries" className="py-20 bg-blue-50" data-id="element-893">
          <div className="container mx-auto px-4" data-id="element-894">
            <h2 className="text-3xl font-bold text-center text-blue-900 mb-16" data-id="element-895">
              Industries We Serve
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-896">
              {industries.map(industry => <div key={industry.id} className="group relative overflow-hidden rounded-lg shadow-md" data-id="element-897">
                  <img src={industry.image} alt={industry.name} className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-898" />
                  <div className="absolute inset-0 bg-gradient-to-t from-blue-900 to-transparent opacity-80" data-id="element-899"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-4" data-id="element-900">
                    <h3 className="text-xl font-bold text-white" data-id="element-901">
                      {industry.name}
                    </h3>
                    <a href="#" className="text-blue-200 hover:text-white transition-colors mt-2 inline-block" data-id="element-902">
                      View Solutions →
                    </a>
                  </div>
                </div>)}
            </div>
          </div>
        </section>
        {/* Innovation Section */}
        <section id="innovation" className="py-20" data-id="element-903">
          <div className="container mx-auto px-4" data-id="element-904">
            <div className="flex flex-col lg:flex-row gap-12 items-center" data-id="element-905">
              <div className="lg:w-1/2" data-id="element-906">
                <h2 className="text-3xl font-bold text-blue-900 mb-6" data-id="element-907">
                  Innovation & Sustainability
                </h2>
                <p className="text-gray-700 mb-6" data-id="element-908">
                  At Puritydefine, we believe that innovation and sustainability
                  go hand in hand. Our Research & Development team is constantly
                  working on new technologies and processes to improve
                  efficiency, reduce waste, and minimize environmental impact.
                </p>
                <p className="text-gray-700 mb-6" data-id="element-909">
                  Our commitment to sustainable manufacturing is reflected in
                  every aspect of our operations, from energy-efficient
                  facilities to eco-friendly materials and packaging solutions.
                </p>
                <div className="space-y-4" data-id="element-910">
                  <div className="flex items-start" data-id="element-911">
                    <div className="bg-blue-100 p-2 rounded-full text-blue-700 mr-4" data-id="element-912">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-913">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" data-id="element-914" />
                      </svg>
                    </div>
                    <div data-id="element-915">
                      <h3 className="text-lg font-semibold text-blue-900" data-id="element-916">
                        R&D Investment
                      </h3>
                      <p className="text-gray-700" data-id="element-917">
                        15% of annual revenue dedicated to research and
                        development.
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-918">
                    <div className="bg-blue-100 p-2 rounded-full text-blue-700 mr-4" data-id="element-919">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-920">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 11l5-5m0 0l5 5m-5-5v12" data-id="element-921" />
                      </svg>
                    </div>
                    <div data-id="element-922">
                      <h3 className="text-lg font-semibold text-blue-900" data-id="element-923">
                        Carbon Reduction
                      </h3>
                      <p className="text-gray-700" data-id="element-924">
                        30% reduction in carbon emissions across our operations
                        since 2018.
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-925">
                    <div className="bg-blue-100 p-2 rounded-full text-blue-700 mr-4" data-id="element-926">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-927">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" data-id="element-928" />
                      </svg>
                    </div>
                    <div data-id="element-929">
                      <h3 className="text-lg font-semibold text-blue-900" data-id="element-930">
                        Patent Portfolio
                      </h3>
                      <p className="text-gray-700" data-id="element-931">
                        Over 25 patents for innovative manufacturing processes
                        and solutions.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="lg:w-1/2" data-id="element-932">
                <img src="https://images.unsplash.com/photo-1581092335397-9583eb92d232?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Innovation at Puritydefine" className="rounded-lg shadow-lg w-full" data-id="element-933" />
              </div>
            </div>
          </div>
        </section>
        {/* About Section */}
        <section id="about" className="py-20 bg-blue-50" data-id="element-934">
          <div className="container mx-auto px-4" data-id="element-935">
            <h2 className="text-3xl font-bold text-center text-blue-900 mb-16" data-id="element-936">
              About Puritydefine
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-937">
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-938">
                <div className="text-4xl text-blue-600 mb-4" data-id="element-939">🏢</div>
                <h3 className="text-xl font-bold text-blue-900 mb-3" data-id="element-940">
                  Our Company
                </h3>
                <p className="text-gray-700" data-id="element-941">
                  Founded in 2010, Puritydefine has grown to become a leading
                  manufacturing solutions provider in Nigeria, with a focus on
                  quality, innovation, and sustainability.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-942">
                <div className="text-4xl text-blue-600 mb-4" data-id="element-943">🧠</div>
                <h3 className="text-xl font-bold text-blue-900 mb-3" data-id="element-944">
                  Our Expertise
                </h3>
                <p className="text-gray-700" data-id="element-945">
                  Our team of engineers, technicians, and industry experts
                  brings decades of combined experience to deliver cutting-edge
                  manufacturing solutions.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-946">
                <div className="text-4xl text-blue-600 mb-4" data-id="element-947">🔍</div>
                <h3 className="text-xl font-bold text-blue-900 mb-3" data-id="element-948">
                  Our Approach
                </h3>
                <p className="text-gray-700" data-id="element-949">
                  We take a collaborative, client-focused approach to every
                  project, ensuring that our solutions are tailored to meet
                  specific needs and challenges.
                </p>
              </div>
            </div>
            <div className="text-center" data-id="element-950">
              <a href="#" className="px-6 py-3 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 transition-colors inline-block" data-id="element-951">
                Learn More About Our Story
              </a>
            </div>
          </div>
        </section>
        {/* Contact Section */}
        <section id="contact" className="py-20" data-id="element-952">
          <div className="container mx-auto px-4" data-id="element-953">
            <h2 className="text-3xl font-bold text-center text-blue-900 mb-16" data-id="element-954">
              Contact Us
            </h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-955">
              <div data-id="element-956">
                <h3 className="text-xl font-bold text-blue-900 mb-4" data-id="element-957">
                  Get In Touch
                </h3>
                <p className="text-gray-700 mb-6" data-id="element-958">
                  Have questions about our manufacturing solutions or want to
                  discuss a potential project? Our team is ready to assist you.
                </p>
                <div className="space-y-4 mb-8" data-id="element-959">
                  <div className="flex items-start" data-id="element-960">
                    <div className="bg-blue-100 p-2 rounded-full text-blue-700 mr-4" data-id="element-961">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-962">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" data-id="element-963" />
                      </svg>
                    </div>
                    <div data-id="element-964">
                      <p className="font-medium" data-id="element-965">Phone</p>
                      <p className="text-gray-600" data-id="element-966">+234 345 678 9012</p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-967">
                    <div className="bg-blue-100 p-2 rounded-full text-blue-700 mr-4" data-id="element-968">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-969">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" data-id="element-970" />
                      </svg>
                    </div>
                    <div data-id="element-971">
                      <p className="font-medium" data-id="element-972">Email</p>
                      <p className="text-gray-600" data-id="element-973">info@puritydefine.com</p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-974">
                    <div className="bg-blue-100 p-2 rounded-full text-blue-700 mr-4" data-id="element-975">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-976">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" data-id="element-977" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" data-id="element-978" />
                      </svg>
                    </div>
                    <div data-id="element-979">
                      <p className="font-medium" data-id="element-980">Address</p>
                      <p className="text-gray-600" data-id="element-981">
                        789 Industrial Parkway
                        <br data-id="element-982" />
                        Port Harcourt, Rivers State
                        <br data-id="element-983" />
                        Nigeria
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div data-id="element-984">
                <form className="bg-white p-6 rounded-lg shadow-md" data-id="element-985">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-986">
                    <div data-id="element-987">
                      <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-988">
                        Name
                      </label>
                      <input type="text" id="name" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-989" />
                    </div>
                    <div data-id="element-990">
                      <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-991">
                        Company
                      </label>
                      <input type="text" id="company" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-992" />
                    </div>
                  </div>
                  <div className="mb-4" data-id="element-993">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-994">
                      Email
                    </label>
                    <input type="email" id="email" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-995" />
                  </div>
                  <div className="mb-4" data-id="element-996">
                    <label htmlFor="interest" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-997">
                      Area of Interest
                    </label>
                    <select id="interest" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-998">
                      <option value="" data-id="element-999">Select an option</option>
                      <option value="manufacturing" data-id="element-1000">
                        Manufacturing Solutions
                      </option>
                      <option value="quality" data-id="element-1001">Quality Assurance</option>
                      <option value="supply" data-id="element-1002">Supply Chain Solutions</option>
                      <option value="sustainable" data-id="element-1003">
                        Sustainable Production
                      </option>
                      <option value="other" data-id="element-1004">Other</option>
                    </select>
                  </div>
                  <div className="mb-4" data-id="element-1005">
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1006">
                      Message
                    </label>
                    <textarea id="message" rows={4} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-1007"></textarea>
                  </div>
                  <button type="submit" className="w-full py-2 px-4 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 transition-colors" data-id="element-1008">
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
      <SubsidiaryFooter name="Puritydefine Nig Ltd" description="Innovative manufacturing solutions with a focus on quality and sustainability." color="bg-blue-900" textColor="text-white" links={footerLinks} logo="https://uploadthingy.s3.us-west-1.amazonaws.com/3HZq8reLfPNsnzSHGf7kcW/PURITY.png" data-id="element-1009" />
    </div>;
}